<template>
  <div class="home">
    <!-- <h1>Welcome to my website.</h1>
    <h1>There are many like it, but this one is mine.</h1> -->
    <EntityAnalysisDemo/>
  </div>
</template>

<script>
import EntityAnalysisDemo from '../components/EntityAnalysisDemo'
export default {
  name: 'Home',
  components: {
    EntityAnalysisDemo
  }
}
</script>
